export enum Face {
  TOP = 0,
  BOTTOM = 1,
  FRONT = 2,  // +Z (south)
  BACK = 3,   // -Z (north)
  RIGHT = 4,  // +X (east)
  LEFT = 5,   // -X (west)
}

export const FACE_NORMALS: [number, number, number][] = [
  [0, 1, 0],   // TOP
  [0, -1, 0],  // BOTTOM
  [0, 0, 1],   // FRONT
  [0, 0, -1],  // BACK
  [1, 0, 0],   // RIGHT
  [-1, 0, 0],  // LEFT
];

export const FACE_OFFSETS: [number, number, number][] = FACE_NORMALS;

export const FACE_NAMES = ['top', 'bottom', 'front', 'back', 'right', 'left'] as const;

export const OPPOSITE_FACE: Face[] = [
  Face.BOTTOM, Face.TOP, Face.BACK, Face.FRONT, Face.LEFT, Face.RIGHT,
];
